const countryListNL = [
    { countryCode: 4, country: "Afghanistan", alpha2: "af", alpha3: "afg" },
    { countryCode: 248, country: "Åland", alpha2: "ax", alpha3: "ala" },
    { countryCode: 8, country: "Albanië", alpha2: "al", alpha3: "alb" },
    { countryCode: 12, country: "Algerije", alpha2: "dz", alpha3: "dza" },
    { countryCode: 850, country: "Amerikaanse Maagdeneilanden", alpha2: "vi", alpha3: "vir" },
    { countryCode: 16, country: "Amerikaans-Samoa", alpha2: "as", alpha3: "asm" },
    { countryCode: 20, country: "Andorra", alpha2: "ad", alpha3: "and" },
    { countryCode: 24, country: "Angola", alpha2: "ao", alpha3: "ago" },
    { countryCode: 660, country: "Anguilla", alpha2: "ai", alpha3: "aia" },
    { countryCode: 10, country: "Antarctica", alpha2: "aq", alpha3: "ata" },
    { countryCode: 28, country: "Antigua en Barbuda", alpha2: "ag", alpha3: "atg" },
    { countryCode: 32, country: "Argentinië", alpha2: "ar", alpha3: "arg" },
    { countryCode: 51, country: "Armenië", alpha2: "am", alpha3: "arm" },
    { countryCode: 533, country: "Aruba", alpha2: "aw", alpha3: "abw" },
    { countryCode: 36, country: "Australië", alpha2: "au", alpha3: "aus" },
    { countryCode: 31, country: "Azerbeidzjan", alpha2: "az", alpha3: "aze" },
    { countryCode: 44, country: "Bahama's", alpha2: "bs", alpha3: "bhs" },
    { countryCode: 48, country: "Bahrein", alpha2: "bh", alpha3: "bhr" },
    { countryCode: 50, country: "Bangladesh", alpha2: "bd", alpha3: "bgd" },
    { countryCode: 52, country: "Barbados", alpha2: "bb", alpha3: "brb" },
    { countryCode: 56, country: "België", alpha2: "be", alpha3: "bel" },
    { countryCode: 84, country: "Belize", alpha2: "bz", alpha3: "blz" },
    { countryCode: 204, country: "Benin", alpha2: "bj", alpha3: "ben" },
    { countryCode: 60, country: "Bermuda", alpha2: "bm", alpha3: "bmu" },
    { countryCode: 64, country: "Bhutan", alpha2: "bt", alpha3: "btn" },
    { countryCode: 68, country: "Bolivia", alpha2: "bo", alpha3: "bol" },
    { countryCode: 70, country: "Bosnië en Herzegovina", alpha2: "ba", alpha3: "bih" },
    { countryCode: 72, country: "Botswana", alpha2: "bw", alpha3: "bwa" },
    { countryCode: 74, country: "Bouveteiland", alpha2: "bv", alpha3: "bvt" },
    { countryCode: 76, country: "Brazilië", alpha2: "br", alpha3: "bra" },
    { countryCode: 92, country: "Britse Maagdeneilanden", alpha2: "vg", alpha3: "vgb" },
    { countryCode: 86, country: "Brits Indische Oceaanterritorium", alpha2: "io", alpha3: "iot" },
    { countryCode: 96, country: "Brunei", alpha2: "bn", alpha3: "brn" },
    { countryCode: 100, country: "Bulgarije", alpha2: "bg", alpha3: "bgr" },
    { countryCode: 854, country: "Burkina Faso", alpha2: "bf", alpha3: "bfa" },
    { countryCode: 108, country: "Burundi", alpha2: "bi", alpha3: "bdi" },
    { countryCode: 116, country: "Cambodja", alpha2: "kh", alpha3: "khm" },
    { countryCode: 124, country: "Canada", alpha2: "ca", alpha3: "can" },
    { countryCode: 535, country: "Caribisch Nederland", alpha2: "bq", alpha3: "bes" },
    { countryCode: 140, country: "Centraal-Afrikaanse Republiek", alpha2: "cf", alpha3: "caf" },
    { countryCode: 152, country: "Chili", alpha2: "cl", alpha3: "chl" },
    { countryCode: 156, country: "China", alpha2: "cn", alpha3: "chn" },
    { countryCode: 162, country: "Christmaseiland", alpha2: "cx", alpha3: "cxr" },
    { countryCode: 166, country: "Cocoseilanden", alpha2: "cc", alpha3: "cck" },
    { countryCode: 170, country: "Colombia", alpha2: "co", alpha3: "col" },
    { countryCode: 174, country: "Comoren", alpha2: "km", alpha3: "com" },
    { countryCode: 178, country: "Congo-Brazzaville", alpha2: "cg", alpha3: "cog" },
    { countryCode: 180, country: "Congo-Kinshasa", alpha2: "cd", alpha3: "cod" },
    { countryCode: 184, country: "Cookeilanden", alpha2: "ck", alpha3: "cok" },
    { countryCode: 188, country: "Costa Rica", alpha2: "cr", alpha3: "cri" },
    { countryCode: 192, country: "Cuba", alpha2: "cu", alpha3: "cub" },
    { countryCode: 531, country: "Curaçao", alpha2: "cw", alpha3: "cuw" },
    { countryCode: 196, country: "Cyprus", alpha2: "cy", alpha3: "cyp" },
    { countryCode: 208, country: "Denemarken", alpha2: "dk", alpha3: "dnk" },
    { countryCode: 262, country: "Djibouti", alpha2: "dj", alpha3: "dji" },
    { countryCode: 212, country: "Dominica", alpha2: "dm", alpha3: "dma" },
    { countryCode: 214, country: "Dominicaanse Republiek", alpha2: "do", alpha3: "dom" },
    { countryCode: 276, country: "Duitsland", alpha2: "de", alpha3: "deu" },
    { countryCode: 218, country: "Ecuador", alpha2: "ec", alpha3: "ecu" },
    { countryCode: 818, country: "Egypte", alpha2: "eg", alpha3: "egy" },
    { countryCode: 222, country: "El Salvador", alpha2: "sv", alpha3: "slv" },
    { countryCode: 226, country: "Equatoriaal-Guinea", alpha2: "gq", alpha3: "gnq" },
    { countryCode: 232, country: "Eritrea", alpha2: "er", alpha3: "eri" },
    { countryCode: 233, country: "Estland", alpha2: "ee", alpha3: "est" },
    { countryCode: 231, country: "Ethiopië", alpha2: "et", alpha3: "eth" },
    { countryCode: 234, country: "Faeröer", alpha2: "fo", alpha3: "fro" },
    { countryCode: 238, country: "Falklandeilanden", alpha2: "fk", alpha3: "flk" },
    { countryCode: 242, country: "Fiji", alpha2: "fj", alpha3: "fji" },
    { countryCode: 608, country: "Filipijnen", alpha2: "ph", alpha3: "phl" },
    { countryCode: 246, country: "Finland", alpha2: "fi", alpha3: "fin" },
    { countryCode: 250, country: "Frankrijk", alpha2: "fr", alpha3: "fra" },
    { countryCode: 260, country: "Franse Zuidelijke en Antarctische Gebieden", alpha2: "tf", alpha3: "atf" },
    { countryCode: 254, country: "Frans-Guyana", alpha2: "gf", alpha3: "guf" },
    { countryCode: 258, country: "Frans-Polynesië", alpha2: "pf", alpha3: "pyf" },
    { countryCode: 266, country: "Gabon", alpha2: "ga", alpha3: "gab" },
    { countryCode: 270, country: "Gambia", alpha2: "gm", alpha3: "gmb" },
    { countryCode: 268, country: "Georgië", alpha2: "ge", alpha3: "geo" },
    { countryCode: 288, country: "Ghana", alpha2: "gh", alpha3: "gha" },
    { countryCode: 292, country: "Gibraltar", alpha2: "gi", alpha3: "gib" },
    { countryCode: 308, country: "Grenada", alpha2: "gd", alpha3: "grd" },
    { countryCode: 300, country: "Griekenland", alpha2: "gr", alpha3: "grc" },
    { countryCode: 304, country: "Groenland", alpha2: "gl", alpha3: "grl" },
    { countryCode: 312, country: "Guadeloupe", alpha2: "gp", alpha3: "glp" },
    { countryCode: 316, country: "Guam", alpha2: "gu", alpha3: "gum" },
    { countryCode: 320, country: "Guatemala", alpha2: "gt", alpha3: "gtm" },
    { countryCode: 831, country: "Guernsey", alpha2: "gg", alpha3: "ggy" },
    { countryCode: 324, country: "Guinee", alpha2: "gn", alpha3: "gin" },
    { countryCode: 624, country: "Guinee-Bissau", alpha2: "gw", alpha3: "gnb" },
    { countryCode: 328, country: "Guyana", alpha2: "gy", alpha3: "guy" },
    { countryCode: 332, country: "Haïti", alpha2: "ht", alpha3: "hti" },
    { countryCode: 334, country: "Heard en McDonaldeilanden", alpha2: "hm", alpha3: "hmd" },
    { countryCode: 340, country: "Honduras", alpha2: "hn", alpha3: "hnd" },
    { countryCode: 348, country: "Hongarije", alpha2: "hu", alpha3: "hun" },
    { countryCode: 344, country: "Hongkong", alpha2: "hk", alpha3: "hkg" },
    { countryCode: 372, country: "Ierland", alpha2: "ie", alpha3: "irl" },
    { countryCode: 352, country: "IJsland", alpha2: "is", alpha3: "isl" },
    { countryCode: 356, country: "India", alpha2: "in", alpha3: "ind" },
    { countryCode: 360, country: "Indonesië", alpha2: "id", alpha3: "idn" },
    { countryCode: 368, country: "Irak", alpha2: "iq", alpha3: "irq" },
    { countryCode: 364, country: "Iran", alpha2: "ir", alpha3: "irn" },
    { countryCode: 376, country: "Israël", alpha2: "il", alpha3: "isr" },
    { countryCode: 380, country: "Italië", alpha2: "it", alpha3: "ita" },
    { countryCode: 384, country: "Ivoorkust", alpha2: "ci", alpha3: "civ" },
    { countryCode: 388, country: "Jamaica", alpha2: "jm", alpha3: "jam" },
    { countryCode: 392, country: "Japan", alpha2: "jp", alpha3: "jpn" },
    { countryCode: 887, country: "Jemen", alpha2: "ye", alpha3: "yem" },
    { countryCode: 832, country: "Jersey", alpha2: "je", alpha3: "jey" },
    { countryCode: 400, country: "Jordanië", alpha2: "jo", alpha3: "jor" },
    { countryCode: 136, country: "Kaaimaneilanden", alpha2: "ky", alpha3: "cym" },
    { countryCode: 132, country: "Kaapverdië", alpha2: "cv", alpha3: "cpv" },
    { countryCode: 120, country: "Kameroen", alpha2: "cm", alpha3: "cmr" },
    { countryCode: 398, country: "Kazachstan", alpha2: "kz", alpha3: "kaz" },
    { countryCode: 404, country: "Kenia", alpha2: "ke", alpha3: "ken" },
    { countryCode: 417, country: "Kirgizië", alpha2: "kg", alpha3: "kgz" },
    { countryCode: 296, country: "Kiribati", alpha2: "ki", alpha3: "kir" },
    { countryCode: 581, country: "Kleine afgelegen eilanden van de Verenigde Staten", alpha2: "um", alpha3: "umi" },
    { countryCode: 414, country: "Koeweit", alpha2: "kw", alpha3: "kwt" },
    { countryCode: 191, country: "Kroatië", alpha2: "hr", alpha3: "hrv" },
    { countryCode: 418, country: "Laos", alpha2: "la", alpha3: "lao" },
    { countryCode: 426, country: "Lesotho", alpha2: "ls", alpha3: "lso" },
    { countryCode: 428, country: "Letland", alpha2: "lv", alpha3: "lva" },
    { countryCode: 422, country: "Libanon", alpha2: "lb", alpha3: "lbn" },
    { countryCode: 430, country: "Liberia", alpha2: "lr", alpha3: "lbr" },
    { countryCode: 434, country: "Libië", alpha2: "ly", alpha3: "lby" },
    { countryCode: 438, country: "Liechtenstein", alpha2: "li", alpha3: "lie" },
    { countryCode: 440, country: "Litouwen", alpha2: "lt", alpha3: "ltu" },
    { countryCode: 442, country: "Luxemburg", alpha2: "lu", alpha3: "lux" },
    { countryCode: 446, country: "Macau", alpha2: "mo", alpha3: "mac" },
    { countryCode: 450, country: "Madagaskar", alpha2: "mg", alpha3: "mdg" },
    { countryCode: 454, country: "Malawi", alpha2: "mw", alpha3: "mwi" },
    { countryCode: 462, country: "Maldiven", alpha2: "mv", alpha3: "mdv" },
    { countryCode: 458, country: "Maleisië", alpha2: "my", alpha3: "mys" },
    { countryCode: 466, country: "Mali", alpha2: "ml", alpha3: "mli" },
    { countryCode: 470, country: "Malta", alpha2: "mt", alpha3: "mlt" },
    { countryCode: 833, country: "Man", alpha2: "im", alpha3: "imn" },
    { countryCode: 504, country: "Marokko", alpha2: "ma", alpha3: "mar" },
    { countryCode: 584, country: "Marshalleilanden", alpha2: "mh", alpha3: "mhl" },
    { countryCode: 474, country: "Martinique", alpha2: "mq", alpha3: "mtq" },
    { countryCode: 478, country: "Mauritanië", alpha2: "mr", alpha3: "mrt" },
    { countryCode: 480, country: "Mauritius", alpha2: "mu", alpha3: "mus" },
    { countryCode: 175, country: "Mayotte", alpha2: "yt", alpha3: "myt" },
    { countryCode: 484, country: "Mexico", alpha2: "mx", alpha3: "mex" },
    { countryCode: 583, country: "Micronesia", alpha2: "fm", alpha3: "fsm" },
    { countryCode: 498, country: "Moldavië", alpha2: "md", alpha3: "mda" },
    { countryCode: 492, country: "Monaco", alpha2: "mc", alpha3: "mco" },
    { countryCode: 496, country: "Mongolië", alpha2: "mn", alpha3: "mng" },
    { countryCode: 499, country: "Montenegro", alpha2: "me", alpha3: "mne" },
    { countryCode: 500, country: "Montserrat", alpha2: "ms", alpha3: "msr" },
    { countryCode: 508, country: "Mozambique", alpha2: "mz", alpha3: "moz" },
    { countryCode: 104, country: "Myanmar", alpha2: "mm", alpha3: "mmr" },
    { countryCode: 516, country: "Namibië", alpha2: "na", alpha3: "nam" },
    { countryCode: 520, country: "Nauru", alpha2: "nr", alpha3: "nru" },
    { countryCode: 528, country: "Nederland", alpha2: "nl", alpha3: "nld" },
    { countryCode: 524, country: "Nepal", alpha2: "np", alpha3: "npl" },
    { countryCode: 558, country: "Nicaragua", alpha2: "ni", alpha3: "nic" },
    { countryCode: 540, country: "Nieuw-Caledonië", alpha2: "nc", alpha3: "ncl" },
    { countryCode: 554, country: "Nieuw-Zeeland", alpha2: "nz", alpha3: "nzl" },
    { countryCode: 562, country: "Niger", alpha2: "ne", alpha3: "ner" },
    { countryCode: 566, country: "Nigeria", alpha2: "ng", alpha3: "nga" },
    { countryCode: 570, country: "Niue", alpha2: "nu", alpha3: "niu" },
    { countryCode: 580, country: "Noordelijke Marianen", alpha2: "mp", alpha3: "mnp" },
    { countryCode: 408, country: "Noord-Korea", alpha2: "kp", alpha3: "prk" },
    { countryCode: 807, country: "Noord-Macedonië", alpha2: "mk", alpha3: "mkd" },
    { countryCode: 578, country: "Noorwegen", alpha2: "no", alpha3: "nor" },
    { countryCode: 574, country: "Norfolk", alpha2: "nf", alpha3: "nfk" },
    { countryCode: 800, country: "Oeganda", alpha2: "ug", alpha3: "uga" },
    { countryCode: 804, country: "Oekraïne", alpha2: "ua", alpha3: "ukr" },
    { countryCode: 860, country: "Oezbekistan", alpha2: "uz", alpha3: "uzb" },
    { countryCode: 512, country: "Oman", alpha2: "om", alpha3: "omn" },
    { countryCode: 40, country: "Oostenrijk", alpha2: "at", alpha3: "aut" },
    { countryCode: 626, country: "Oost-Timor", alpha2: "tl", alpha3: "tls" },
    { countryCode: 586, country: "Pakistan", alpha2: "pk", alpha3: "pak" },
    { countryCode: 585, country: "Palau", alpha2: "pw", alpha3: "plw" },
    { countryCode: 275, country: "Palestina", alpha2: "ps", alpha3: "pse" },
    { countryCode: 591, country: "Panama", alpha2: "pa", alpha3: "pan" },
    { countryCode: 598, country: "Papoea-Nieuw-Guinea", alpha2: "pg", alpha3: "png" },
    { countryCode: 600, country: "Paraguay", alpha2: "py", alpha3: "pry" },
    { countryCode: 604, country: "Peru", alpha2: "pe", alpha3: "per" },
    { countryCode: 612, country: "Pitcairneilanden", alpha2: "pn", alpha3: "pcn" },
    { countryCode: 616, country: "Polen", alpha2: "pl", alpha3: "pol" },
    { countryCode: 620, country: "Portugal", alpha2: "pt", alpha3: "prt" },
    { countryCode: 630, country: "Puerto Rico", alpha2: "pr", alpha3: "pri" },
    { countryCode: 634, country: "Qatar", alpha2: "qa", alpha3: "qat" },
    { countryCode: 638, country: "Réunion", alpha2: "re", alpha3: "reu" },
    { countryCode: 642, country: "Roemenië", alpha2: "ro", alpha3: "rou" },
    { countryCode: 643, country: "Rusland", alpha2: "ru", alpha3: "rus" },
    { countryCode: 646, country: "Rwanda", alpha2: "rw", alpha3: "rwa" },
    { countryCode: 652, country: "Saint-Barthélemy", alpha2: "bl", alpha3: "blm" },
    { countryCode: 659, country: "Saint Kitts en Nevis", alpha2: "kn", alpha3: "kna" },
    { countryCode: 662, country: "Saint Lucia", alpha2: "lc", alpha3: "lca" },
    { countryCode: 666, country: "Saint-Pierre en Miquelon", alpha2: "pm", alpha3: "spm" },
    { countryCode: 670, country: "Saint Vincent en de Grenadines", alpha2: "vc", alpha3: "vct" },
    { countryCode: 90, country: "Salomonseilanden", alpha2: "sb", alpha3: "slb" },
    { countryCode: 882, country: "Samoa", alpha2: "ws", alpha3: "wsm" },
    { countryCode: 674, country: "San Marino", alpha2: "sm", alpha3: "smr" },
    { countryCode: 682, country: "Saoedi-Arabië", alpha2: "sa", alpha3: "sau" },
    { countryCode: 678, country: "Sao Tomé en Principe", alpha2: "st", alpha3: "stp" },
    { countryCode: 686, country: "Senegal", alpha2: "sn", alpha3: "sen" },
    { countryCode: 688, country: "Servië", alpha2: "rs", alpha3: "srb" },
    { countryCode: 690, country: "Seychellen", alpha2: "sc", alpha3: "syc" },
    { countryCode: 694, country: "Sierra Leone", alpha2: "sl", alpha3: "sle" },
    { countryCode: 702, country: "Singapore", alpha2: "sg", alpha3: "sgp" },
    { countryCode: 654, country: "Sint-Helena, Ascension en Tristan da Cunha", alpha2: "sh", alpha3: "shn" },
    { countryCode: 663, country: "Sint-Maarten", alpha2: "mf", alpha3: "maf" },
    { countryCode: 534, country: "Sint Maarten", alpha2: "sx", alpha3: "sxm" },
    { countryCode: 705, country: "Slovenië", alpha2: "si", alpha3: "svn" },
    { countryCode: 703, country: "Slowakije", alpha2: "sk", alpha3: "svk" },
    { countryCode: 729, country: "Soedan", alpha2: "sd", alpha3: "sdn" },
    { countryCode: 706, country: "Somalië", alpha2: "so", alpha3: "som" },
    { countryCode: 724, country: "Spanje", alpha2: "es", alpha3: "esp" },
    { countryCode: 744, country: "Spitsbergen en Jan Mayen", alpha2: "sj", alpha3: "sjm" },
    { countryCode: 144, country: "Sri Lanka", alpha2: "lk", alpha3: "lka" },
    { countryCode: 740, country: "Suricountry", alpha2: "sr", alpha3: "sur" },
    { countryCode: 748, country: "Swaziland", alpha2: "sz", alpha3: "swz" },
    { countryCode: 760, country: "Syrië", alpha2: "sy", alpha3: "syr" },
    { countryCode: 762, country: "Tadzjikistan", alpha2: "tj", alpha3: "tjk" },
    { countryCode: 158, country: "Taiwan", alpha2: "tw", alpha3: "twn" },
    { countryCode: 834, country: "Tanzania", alpha2: "tz", alpha3: "tza" },
    { countryCode: 764, country: "Thailand", alpha2: "th", alpha3: "tha" },
    { countryCode: 768, country: "Togo", alpha2: "tg", alpha3: "tgo" },
    { countryCode: 772, country: "Tokelau", alpha2: "tk", alpha3: "tkl" },
    { countryCode: 776, country: "Tonga", alpha2: "to", alpha3: "ton" },
    { countryCode: 780, country: "Trinidad en Tobago", alpha2: "tt", alpha3: "tto" },
    { countryCode: 148, country: "Tsjaad", alpha2: "td", alpha3: "tcd" },
    { countryCode: 203, country: "Tsjechië", alpha2: "cz", alpha3: "cze" },
    { countryCode: 788, country: "Tunesië", alpha2: "tn", alpha3: "tun" },
    { countryCode: 792, country: "Turkije", alpha2: "tr", alpha3: "tur" },
    { countryCode: 795, country: "Turkmenistan", alpha2: "tm", alpha3: "tkm" },
    { countryCode: 796, country: "Turks- en Caicoseilanden", alpha2: "tc", alpha3: "tca" },
    { countryCode: 798, country: "Tuvalu", alpha2: "tv", alpha3: "tuv" },
    { countryCode: 858, country: "Uruguay", alpha2: "uy", alpha3: "ury" },
    { countryCode: 548, country: "Vanuatu", alpha2: "vu", alpha3: "vut" },
    { countryCode: 336, country: "Vaticaanstad", alpha2: "va", alpha3: "vat" },
    { countryCode: 862, country: "Venezuela", alpha2: "ve", alpha3: "ven" },
    { countryCode: 784, country: "Verenigde Arabische Emiraten", alpha2: "ae", alpha3: "are" },
    { countryCode: 840, country: "Verenigde Staten", alpha2: "us", alpha3: "usa" },
    { countryCode: 826, country: "Verenigd Koninkrijk", alpha2: "gb", alpha3: "gbr" },
    { countryCode: 704, country: "Vietnam", alpha2: "vn", alpha3: "vnm" },
    { countryCode: 876, country: "Wallis en Futuna", alpha2: "wf", alpha3: "wlf" },
    { countryCode: 732, country: "Westelijke Sahara", alpha2: "eh", alpha3: "esh" },
    { countryCode: 112, country: "Wit-Rusland", alpha2: "by", alpha3: "blr" },
    { countryCode: 894, country: "Zambia", alpha2: "zm", alpha3: "zmb" },
    { countryCode: 716, country: "Zimbabwe", alpha2: "zw", alpha3: "zwe" },
    { countryCode: 710, country: "Zuid-Afrika", alpha2: "za", alpha3: "zaf" },
    {
        countryCode: 239,
        country: "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
        alpha2: "gs",
        alpha3: "sgs",
    },
    { countryCode: 410, country: "Zuid-Korea", alpha2: "kr", alpha3: "kor" },
    { countryCode: 728, country: "Zuid-Soedan", alpha2: "ss", alpha3: "ssd" },
    { countryCode: 752, country: "Zweden", alpha2: "se", alpha3: "swe" },
    { countryCode: 756, country: "Zwitserland", alpha2: "ch", alpha3: "che" },
];
export default countryListNL;
